<template>
    <b-modal id="editModal" ref="modal" title="Edit Fertiliser Additive" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Fertiliser Additive Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-link text-danger mr-auto" @click="handleDelete" v-if="!fertiliserAdditive.deleted_at">
                Disable
            </button>
            <button class="btn btn-link text-danger mr-auto" @click="handleRestore" v-if="fertiliserAdditive.deleted_at">
                Restore
            </button>
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import deleteFertiliserAdditiveMutation from '@views/FertiliserAdditives/EditModal/mutationDeleteFertiliserAdditive.graphql';
import restoreFertiliserAdditiveMutation from '@views/FertiliserAdditives/EditModal/mutationRestoreFertiliserAdditive.graphql';
import updateFertiliserAdditiveMutation from '@views/FertiliserAdditives/EditModal/mutationUpdateFertiliserAdditive.graphql';

export default {
  name: 'edit-modal',
  apollo: {},
  props: {
    fertiliserAdditive: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      name: this.fertiliserAdditive.name,
      show: true,
      loading: 0,
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: updateFertiliserAdditiveMutation,
            variables: {
              input: {
                id: this.fertiliserAdditive.id,
                name: this.name,
              },
            },
            optimisticResponse: {
              __typename: 'Mutation',
              updateFertiliserAdditive: {
                ...this.fertiliserAdditive,
                name: this.name,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Fertiliser Additive updated!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure('Unfortunately, we were unable to do that!');
          });
      });
    },
    handleDelete() {
      this.$apollo
        .mutate({
          mutation: deleteFertiliserAdditiveMutation,
          variables: {
            input: {
              id: this.fertiliserAdditive.id,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Fertiliser Additive disabled!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure('Unfortunately, we were unable to do that!');
        });
    },
    handleRestore() {
      this.$apollo
        .mutate({
          mutation: restoreFertiliserAdditiveMutation,
          variables: {
            input: {
              id: this.fertiliserAdditive.id,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            restoreFertiliserAdditive: {
              ...this.fertiliserAdditive,
              deleted_at: null,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Fertiliser Additive restored!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure('Unfortunately, we were unable to do that!');
        });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
